// extracted by mini-css-extract-plugin
export default {"errorCode":"Error404Text_errorCode__w1lyE","errorMsg1":"Error404Text_errorMsg1__pWH2-","errorMsg2":"Error404Text_errorMsg2__2l94l"};